<template>
  <div v-if="isLoaded && (loggedIn || isAnonymous)">
    <AppHeader></AppHeader>
    <v-main>
      <router-view :key="routeViewKey"></router-view>
      <snack-stack />
      <dynamic-dialog></dynamic-dialog>
      <loading-dialog></loading-dialog>
    </v-main>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SnackStack from '../components/basic/SnackStack';
import AppHeader from '../components/AppHeader.vue';
import DynamicDialog from '../components/basic/DynamicDialog.vue';
import LoadingDialog from '../components/basic/LoadingDialog.vue'
const { getRouteViewKey } = require('../utils/sumarFlow');

export default {
  components: {
    AppHeader,
    SnackStack,
    DynamicDialog,
    LoadingDialog
  },
  computed: {
    ...mapGetters('auth', ['loggedIn', 'isAnonymous', 'isLoaded']),
    routeViewKey() {
      return getRouteViewKey(this.$route);
    },
  },
  data: () => ({
    //
  }),
  created() {
    this.$store.dispatch('getPravoNaAdresnuPonuku');
    this.$store.dispatch('getPravoDodatocneKalkVstupy');
    this.$store.dispatch('getTimeToCallApiAgain');
  },
};
</script>
